export default "__VITE_ASSET__a4af85ed__"